import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomCreateAiMappingSegmentationMutation } from "generated/graphql";

export const useCreateAiMappingSegmentation = () => {
  const [mutation, { data, loading, error }] = useCustomCreateAiMappingSegmentationMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "createAiMappingSegmentation" },
    { hideMessage: true }
  );
};
